module.exports = __webpack_public_path__ + "static/media/surat_lamaran.40c82c52.jpg";